/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignMassMessageRequest } from '../models/AssignMassMessageRequest';
import type { AssignTrackedTipRequest } from '../models/AssignTrackedTipRequest';
import type { GetMassMessageSendersRequest } from '../models/GetMassMessageSendersRequest';
import type { GetMassMessageSendersResponse } from '../models/GetMassMessageSendersResponse';
import type { OnlyFansMassMessage } from '../models/OnlyFansMassMessage';
import type { OnlyFansMassMessageRequest } from '../models/OnlyFansMassMessageRequest';
import type { Pageable } from '../models/Pageable';
import type { PageSentMessage } from '../models/PageSentMessage';
import type { PaginatedMessageAuthors } from '../models/PaginatedMessageAuthors';
import type { RecordTrackingForm } from '../models/RecordTrackingForm';
import type { SaveTrackingMessageForm } from '../models/SaveTrackingMessageForm';
import type { SentMessageFilters } from '../models/SentMessageFilters';
import type { TipTrackingForm } from '../models/TipTrackingForm';
import type { TipTrackingLatestMetadata } from '../models/TipTrackingLatestMetadata';
import type { TrackingMessageSender } from '../models/TrackingMessageSender';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TrackingService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static recordTrackingDashboard({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: RecordTrackingForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/{creatorId}/record-tracking',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Save and return OF message
     * @returns OnlyFansMassMessage OK
     * @throws ApiError
     */
    public static saveSentMessages({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        onlyfansId: number,
        /**
         * The ID of the browser.
         */
        browserId: string,
        requestBody: OnlyFansMassMessageRequest,
    }): CancelablePromise<OnlyFansMassMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/onlyfans-mass-message/{onlyfansId}/{browserId}',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Retrieve mass message senders
     * @returns GetMassMessageSendersResponse OK
     * @throws ApiError
     */
    public static getMassMessageSenders({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        onlyfansId: number,
        /**
         * The ID of the browser.
         */
        browserId: string,
        requestBody: GetMassMessageSendersRequest,
    }): CancelablePromise<GetMassMessageSendersResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/onlyfans-mass-message/senders/{onlyfansId}/{browserId}',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Assign sender of mass message
     * @returns any OK
     * @throws ApiError
     */
    public static extensionOnlyFansMassMessageRestEndpointAssignMassMessageSender({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        /**
         * The ID of the creator.
         */
        onlyfansId: number,
        /**
         * The ID of the browser.
         */
        browserId: string,
        requestBody: AssignMassMessageRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/onlyfans-mass-message/assign/{onlyfansId}/{browserId}',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Records tracking data by of the sending browser
     * Records and stores the retrieved data by the browser for the current timestamp.
     *
     * The timestamp is recorded minutely through the `timestamp` field. This is
     * the only required field.
     *
     * The request is designed to be once per minute, however it is tolerant
     * tolerant towards merging date for the same record.
     *
     * @returns any The data has been recorded.
     * @throws ApiError
     */
    public static recordTracking({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        /**
         * Id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
        /**
         *   The Tracking data to be recorded.
         * All fields are optional, however each of them need to be in a valid format
         * (e.g. >= 0). The individual restrictions are explained in the respective fields.
         * Data that has been already collected will be accumulated.
         *
         */
        requestBody: RecordTrackingForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * Queries metadata of last transmitted tips and blocks transmission
     * Used before collecting tips to receive metadata information (in order
     * to check which tips have not been transmitted yet) and thus can return
     * a blocked (423) error, if the tips are already being collected by another
     * browser.
     *
     * If successful, the action is blocked for other browsers and
     * the timestamp as well as the id of the newest tip
     * (newest `createdAt` in last recorded tip) are returned.
     *
     * @returns TipTrackingLatestMetadata The timestamps of the last transmitted data.
     * @throws ApiError
     */
    public static findLatestMetadata({
        onlyfansId,
        browserId,
    }: {
        /**
         * Id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
    }): CancelablePromise<TipTrackingLatestMetadata> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/tips',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
                423: `The transmission is blocked since another browser is already transmitting tips.
                `,
            },
        });
    }
    /**
     * Collect tips
     * This endpoints records and stores all tips that are newer than the
     * `lastTipsUpdateTime` from the [metadata endpoint](#/Tracking/findLatestMetadata).
     * Thus, before calling this endpoint, the [metadata endpoint](#/Tracking/findLatestMetadata)
     * must be called to ensure uniqueness in the transmitted tips.
     *
     * The request accepts directly the OF-Response as shown below. There is no
     * temporal limitation or preference to when this endpoint has to be called,
     * however a regularly update and use is recommended.
     *
     * After calling this endpoint, call the [unblock transmission-endpoint](#/Tracking/unblocksAction)
     * to unblock this action.
     *
     * @returns any The data has been collected and stored.
     * @throws ApiError
     */
    public static collectTips({
        onlyfansId,
        browserId,
        requestBody,
        saveTransmissionMetadata = true,
    }: {
        /**
         * Id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
        /**
         * The tips to be collected.
         */
        requestBody: TipTrackingForm,
        saveTransmissionMetadata?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/tips',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            query: {
                'saveTransmissionMetadata': saveTransmissionMetadata,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * Unblocks tips-transmission
     * Used after collecting tips to unblock action for other browsers.
     *
     * @returns any Action has been unblocked.
     * @throws ApiError
     */
    public static unblocksAction({
        onlyfansId,
        browserId,
    }: {
        /**
         * Id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/tips',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static apiAssignTip({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        onlyfansId: number,
        browserId: string,
        requestBody: AssignTrackedTipRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/tips/assign',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Find message authors
     * Finds and returns all authors to the request messages:
     *
     * All message Onlyfans ids that will be sent through query parameters
     * will be returned with the corresponding message author
     * (browser/extension name) if the sending browser has access to
     * this message (same creator).
     *
     * The onlyfans ids are provided like this:
     * `.../message?onlyfansIds=1&onlyfansIds=2&onlyfansIds=3...`.
     *
     * @returns PaginatedMessageAuthors The message authors.
     * @throws ApiError
     */
    public static findMessageAuthors({
        onlyfansId,
        browserId,
        onlyfansIds,
    }: {
        /**
         * Onlyfans id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
        /**
         * The Onlyfans ids of the messages. Each provided through a query parameter.
         */
        onlyfansIds: Array<number>,
    }): CancelablePromise<PaginatedMessageAuthors> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/message',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            query: {
                'onlyfansIds': onlyfansIds,
            },
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * Save sent message
     * Saves a message sent by the request-sending browser.
     *
     * @returns any The message has been saved.
     * @throws ApiError
     */
    public static saveMessage({
        onlyfansId,
        browserId,
        requestBody,
    }: {
        /**
         * Onlyfans id of the creator.
         */
        onlyfansId: number,
        /**
         * The (authenticating) id of the sending browser.
         */
        browserId: string,
        /**
         *   The message (data) to be saved.
         *
         */
        requestBody: SaveTrackingMessageForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/creator/{onlyfansId}/settings/browsers/{browserId}/tracking/message',
            path: {
                'onlyfansId': onlyfansId,
                'browserId': browserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The received browserId is in an invalid (non-UUID) format.
                `,
                403: `The browser is not authorized for this creator
                or the creator has not the required license plan.
                `,
            },
        });
    }
    /**
     * @returns PageSentMessage OK
     * @throws ApiError
     */
    public static getSentMessages({
        creatorId,
        filter,
        pagination,
        sortDirection = 'DESC',
    }: {
        creatorId: number,
        filter: SentMessageFilters,
        pagination: Pageable,
        sortDirection?: 'ASC' | 'DESC',
    }): CancelablePromise<PageSentMessage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/tracking/{creatorId}/messages/sent',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'sortDirection': sortDirection,
                'filter': filter,
                'pagination': pagination,
            },
        });
    }
    /**
     * @returns TrackingMessageSender OK
     * @throws ApiError
     */
    public static getSenders({
        creatorId,
        filter,
    }: {
        creatorId: number,
        filter: SentMessageFilters,
    }): CancelablePromise<Array<TrackingMessageSender>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/tracking/{creatorId}/messages/senders',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'filter': filter,
            },
        });
    }
}
